module.exports = __webpack_public_path__ + "static/media/Avernus1.8bbd1089.jpg";